import { Link } from 'react-router-dom';
import { formatUSD } from '../data/countries';
import { useCountryOverride } from '../hooks/useOverrides';

export default function CountryCard({ country, size = 'default' }){
  const Component = Link;
  const to = `/countries/${country.slug}`;
  const validLabel = country.validity;
  const override = useCountryOverride(country.slug);
  const heroSrc = override.hero || country.image;
  return (
    <Component to={to} className={size === 'small' ? 'else-card reveal' : 'country reveal'} aria-label={`${country.name} ${country.visaName}`}>
      <img src={heroSrc} alt={`${country.name} landscape — ${country.visaName}`} loading="lazy" />
      <div className={size === 'small' ? 'else-body' : 'country-body'}>
        <div className={size === 'small' ? 'else-region' : 'country-region'}>{country.regionLabel}</div>
        <div className={size === 'small' ? 'else-name' : 'country-name'}>{country.name}</div>
        {size === 'small' ? (
          <div className="else-meta">From {formatUSD(country.minIncome)}/mo · {validLabel}</div>
        ) : (
          <div className="country-stats">
            <div className="country-stat"><span className="country-stat-label">From</span><span className="country-stat-val">{formatUSD(country.minIncome)}/mo</span></div>
            <div className="country-stat"><span className="country-stat-label">Valid</span><span className="country-stat-val">{validLabel}</span></div>
          </div>
        )}
      </div>
    </Component>
  );
}
